"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _container = _interopRequireDefault(require("./container"));

var _label = _interopRequireDefault(require("./label"));

var _formGlyph = _interopRequireDefault(require("./form-glyph"));

var _utils = require("../../utils");

var _excluded = ["disabled"],
    _excluded2 = ["bottomLabel", "children", "className", "containerTag", "disabled", "dropDown", "error", "hasFocus", "leftGlyphFill", "glyphLeft", "glyphRight", "id", "label", "required", "rightGlyphFill", "showValue", "success", "topLabel", "type"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ComponentContainer = (0, _styledComponents["default"])(function (_ref) {
  var disabled = _ref.disabled,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, props);
}).withConfig({
  displayName: "element__ComponentContainer",
  componentId: "sc-11jepk5-0"
})(["", ";"], function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? "opacity: 0.6;" : null;
});
var Wrapper = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "element__Wrapper",
  componentId: "sc-11jepk5-1"
})(["position:relative;z-index:10;"]);
var displayProps = ["height", "width", "weight", "m", "mx", "my", "ml", "mr", "mt", "mb"];
var RightGlyph = (0, _styledComponents["default"])(_formGlyph["default"]).withConfig({
  displayName: "element__RightGlyph",
  componentId: "sc-11jepk5-2"
})(["position:absolute;right:0;"]);
var propTypes = {
  /** Label for the input field */
  bottomLabel: _propTypes.node,

  /** Children node */
  children: _propTypes.node,

  /** class name passed in */
  className: _propTypes.string,

  /** type of tag used for container */
  containerTag: _propTypes.string,

  /** A boolean to represent whether the input field should be disabled */
  disabled: _propTypes.bool,

  /** node passed in for drop down */
  dropDown: _propTypes.node,

  /** A boolean to represent whether the input field has a status of error */
  error: _propTypes.bool,

  /** onFocus event handler - used to process the event */
  glyphLeft: _propTypes.node,

  /** Glyph node */
  glyphRight: _propTypes.node,

  /** Bool if element has focus */
  hasFocus: _propTypes.bool,

  /** Glyph node */
  id: _propTypes.string,

  /** String for input field id */
  label: _propTypes.node,

  /** color for left glyph */
  leftGlyphFill: _propTypes.string,

  /** Function to handle on focus event */
  onFocus: _propTypes.func,

  /** Pattern string to handle validation */
  pattern: _propTypes.string,

  /** Placeholder text to show while input is empty */
  placeholder: _propTypes.string,

  /** A boolean to represent whether the input field should be validated */
  required: _propTypes.bool,

  /** color for right glyph */
  rightGlyphFill: _propTypes.string,

  /** A boolean to represent whether the value should be shown */
  showValue: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),

  /** A boolean to represent whether the input field has a status of success */
  success: _propTypes.bool,

  /** Label for the input field */
  topLabel: _propTypes.node,

  /** type of field */
  type: _propTypes.string
};
var defaultProps = {
  disabled: false,
  error: false,
  leftGlyphFill: "icon-input",
  rightGlyphFill: "icon-input",
  success: false
};

var FormElement = function FormElement(_ref3) {
  var bottomLabel = _ref3.bottomLabel,
      children = _ref3.children,
      className = _ref3.className,
      containerTag = _ref3.containerTag,
      disabled = _ref3.disabled,
      dropDown = _ref3.dropDown,
      error = _ref3.error,
      hasFocus = _ref3.hasFocus,
      leftGlyphFill = _ref3.leftGlyphFill,
      glyphLeft = _ref3.glyphLeft,
      glyphRight = _ref3.glyphRight,
      id = _ref3.id,
      label = _ref3.label,
      required = _ref3.required,
      rightGlyphFill = _ref3.rightGlyphFill,
      showValue = _ref3.showValue,
      success = _ref3.success,
      topLabel = _ref3.topLabel,
      type = _ref3.type,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded2);

  var _useHover = (0, _utils.useHover)(false),
      hasHover = _useHover[0],
      handleMouseOut = _useHover[1],
      handleMouseOver = _useHover[2];

  return /*#__PURE__*/_react["default"].createElement(ComponentContainer, _extends({
    className: className,
    disabled: disabled
  }, (0, _ramda.pick)(displayProps, props)), topLabel ? /*#__PURE__*/_react["default"].createElement(_label["default"], {
    fieldId: id,
    label: topLabel,
    labelPosition: "top"
  }) : null, /*#__PURE__*/_react["default"].createElement(_container["default"], _extends({
    error: error,
    fieldId: id,
    handleMouseOut: handleMouseOut,
    handleMouseOver: handleMouseOver,
    hasFocus: !disabled && hasFocus,
    hasHover: !disabled && hasHover,
    pb: type === "textarea" ? 2 : 0,
    required: required,
    showValue: showValue,
    success: success,
    tag: containerTag
  }, (0, _ramda.pick)(["width", "height"], props)), glyphLeft ? /*#__PURE__*/_react["default"].createElement(_formGlyph["default"], {
    fill: leftGlyphFill,
    id: glyphLeft,
    ml: 1
  }) : null, /*#__PURE__*/_react["default"].createElement(Wrapper, {
    flex: 1
  }, label ? /*#__PURE__*/_react["default"].createElement(_label["default"], {
    error: error,
    fieldId: id,
    hasFocus: !disabled && hasFocus,
    hasHover: !disabled && hasHover,
    label: label,
    labelPosition: "placeholder",
    required: required,
    showValue: showValue,
    success: success
  }) : null, children), glyphRight ? /*#__PURE__*/_react["default"].createElement(RightGlyph, {
    fill: rightGlyphFill,
    id: glyphRight,
    mr: 1
  }) : null), bottomLabel ? /*#__PURE__*/_react["default"].createElement(_label["default"], {
    fieldId: id,
    label: bottomLabel,
    labelPosition: "bottom"
  }) : null, dropDown);
};

FormElement.propTypes = propTypes;
FormElement.defaultProps = defaultProps;
FormElement.displayName = "Modules.FormElement";
var _default = FormElement;
exports["default"] = _default;